import useIsInApp from '@/hooks/use-is-in-app'
import { TStrapiV4GreenStickyCta } from '../../common-types'
import { eventData, eventMapping } from '../../strapi-v4.tracking'
import { useUserRQInfo } from '@/components/Common/user-provider/user-provider'
import { GreenButton } from '@/components/NewHomepage/Button'

type TProps = TStrapiV4GreenStickyCta

export function StrapiV4GreenStickyCTA(props: TProps) {
  const { isNotAuthenticated } = useUserRQInfo()
  const isInApp = useIsInApp()
  const { text, loginBottomSheet = false, eventName } = props

  if (isNotAuthenticated && !isInApp) {
    return (
      <div className="sticky bottom-0 z-20 block lg:hidden">
        <GreenButton
          btnText={text ?? 'Login/Sign Up'}
          withLogin={loginBottomSheet}
          eventAction={eventName}
          addclassName="!rounded-none"
          clickEventData={eventMapping[eventData.bottomStickyCtaClick]}
        />
      </div>
    )
  } else return null
}
